import Api from '@/services/Api'

export default {
    getAllTipoContrato(){
        return Api().get('tipoContrato/getAll')
    },
    getTipoContratoById(id){
        return Api().get('tipoContrato/tipoContratoById/'+id)
    },
    createTipoContrato(datos){
        return Api().post('tipoContrato/create',datos)
    },
    updateTipoContratoById(datos){
        return Api().put('tipoContrato/update',datos)
    },
    deleteTipoContrato(id){
        return Api().delete('tipoContrato/delete/'+id)
    }
}